import { Integration } from '../types/integration';

export const integrations: Integration[] = [
  {
    id: 'acculynx',
    name: 'AccuLynx',
    description:
      'Connect your AccuLynx CRM to sync contacts, jobs, and photos.',
    icon: 'crm',
    imageUrl: '/images/acculynx-logo.png',
    status: 'available',
    features: [
      'Sync contacts and deals',
      'Real-time project updates',
      'Automated workflow triggers',
    ],
    setupUrl: '/settings/integrations/acculynx/setup',
  },
  {
    id: 'leap',
    name: 'Leap',
    description: 'Connect your Leap account to sync workflow stages and jobs.',
    icon: 'crm',
    imageUrl: '/images/Leap_Logo.jpg',
    status: 'available',
    features: [
      'Pull workflow stages from Leap',
      'Map to Paiv stages',
      'Sync jobs both ways',
    ],
    setupUrl: '/settings/integrations/leap/setup',
  },
  {
    id: 'jobnimbus',
    name: 'JobNimbus',
    description:
      'Connect Paiv with JobNimbus to streamline your roofing business operations.',
    icon: 'crm',
    imageUrl: '/images/jobnimbus-logo.png',
    status: 'available',
    features: [
      'Lead and opportunity tracking',
      'Project management integration',
    ],
    setupUrl: '/settings/integrations/jobnimbus/setup',
  },
];
